import '../../Assets/Styles/home.css';
import '../../Assets/Styles/partner.css';
import React from "react";
import { useMediaQuery } from 'react-responsive'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {useNavigate} from 'react-router-dom';

import { Helmet } from 'react-helmet';

import { Button } from 'primereact/button'; 

import { ConfirmDialog } from 'primereact/confirmdialog';
import { confirmDialog } from 'primereact/confirmdialog';
import { ProgressSpinner } from 'primereact/progressspinner';

import jwtDecode from 'jwt-decode';

// Load Actions
import * as AppActions from '../../Store/Actions/App'
import * as PartnerActions from '../../Store/Actions/Partner'

// Load Componentes
import AlertView from '../../Components/AlertModal';
import HeaderView from '../../Components/Layout/Header';
import CustomStepper from '../../Components/Partner/CustomStepper'
import RegisterStep1 from './Register-step1';
import RegisterStep2 from './Register-step2'; 
import RegisterStep3 from './Register-step3'; 
import RegisterStep4 from './Register-step4'; 
import RegisterStep5 from './Register-step5'; 
import RegisterStep6 from './Register-step6';
import RegisterConfirm from './Register-confirmation'; // Confirmation screen

// Set assets
// import backgroundPartnerHome from '../../Assets/Images/backgroundPartnerHomeResTeste.png';

import {
    handleClickScroll,
    ValidatorsMap,
    getNestedValue,
    tokenizarCartao
} from '../../Components/Utils';

const RegisterMain = (props) => {
    
// Set var from props
const {
    setDialog,
    setLoginStatus,
    loginStatus,
    currentCompanyStatus,
    activationStatus,
    setActivationStatus,
    partnerStepData,
    retrieveCompanyServices,
    retrieveCompanySpecialities,
    retrieveCompanyDiscounts,
    servicesList,
    specialitiesList,
    updateStepData,
    setGlobalInnerLoading,
    setGlobalInnerMessage,
    registerPartner,
    setUserProfile,
    userProfile
} = props;


// set Use of history for PUSH 
var navigate = useNavigate();

   
const isDesktopOrLaptop = useMediaQuery({
query: '(min-width: 1024px)'
})
const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' })
const isMobile = useMediaQuery({ query: '(max-width: 767px)' })


const [activeStep, setActiveStep] = React.useState(0);
const totalSteps = 6; // total steps of the stepper

const [completedSteps, setCompletedSteps] = React.useState([]);

// Alert control
const [alert, setAlert] = React.useState(false); 
const [alertTitle, setAlertTitle] = React.useState("Informações"); 
const [alertBody, setAlertBody] = React.useState("Conteúdo dinâmico"); 
const [alertAction, setAlertAction] = React.useState(null);

const [submitConfirmVisible, setSubmitConfirmVisible] = React.useState(false);

const [saving, setSaving] = React.useState(false); 

/*
console.log('[activeStep]-------------> '+JSON.stringify(activeStep,null,2));
console.log('[completedSteps]-------------> '+JSON.stringify(completedSteps,null,2));
console.log('[partnerStepData]-------------> '+JSON.stringify(partnerStepData,null,2));*/

// Run after mount component
React.useEffect(() => {
       
  // set scroll to top
  window.scrollTo({ top: 0, behavior: 'smooth' });
  setSaving(false);

    // Retrieve User Data Obj. 
    var result = localStorage.getItem("@estacaodoolho/userData");
    const userData = (() => { try { return jwtDecode(result); } catch { return {}; } })();
  
      // If logged as partner exist, redirect to home 
      if (userData.CompanyPersonUserId && userProfile == 'partner') {
        setActiveStep(6); //navigate("/");
        return;
      } else if (userData.CompanyPersonUserId && userProfile == 'customer') {
        // If logged as customer, redirect to customer home
        navigate("/");
        return;
      }

  // Runs when UNMOUNT component
  return () => {
    
    // unmount...	
    
  };
  
}, []); 

const stepValidations = {
  0: {
    requiredFields:[
      'companyDocument',
      'companyLegalName',
      'companyPersonDocument',
      'companyPersonName',
      'personUserPhone',
      'personUserEmail',
      'personUserEmailConfirm',
      'personUserPassword',
      'personUserPasswordConfirm'
    ],
    /*fieldMatches:[], /*[
      {
        field: 'personUserEmailConfirm',    // campo que está sendo validado
        matchTo: 'personUserEmail',         // campo que ele deve ser igual
        errorMessage: 'Os e-mails não conferem.' // mensagem de erro
      },
      {
        field: 'personUserPasswordConfirm',
        matchTo: 'personUserPassword',
        errorMessage: 'As senhas não conferem.'
      }
    ],*/
    fieldMatches: [ 
      { field: 'personUserEmail', matchTo: 'personUserEmailConfirm', errorMessage: 'Os e-mails não conferem.' },
      { field: 'personUserPassword', matchTo: 'personUserPasswordConfirm', errorMessage: 'As senhas não conferem.' }
    ],
    actionRequired:'validatedContact',
    fieldValidations:[
      { field: 'companyDocument', validator: 'validarCNPJ', errorMessage: 'CNPJ inválido.' },
      { field: 'companyPersonDocument', validator: 'validarCPF', errorMessage: 'CPF inválido.' },
      { field: 'personUserEmail', validator: 'validarEmail', errorMessage: 'Email inválido.' },
      { field: 'personUserPhone', validator: 'validarTelefone', errorMessage: 'Telefone inválido.' },
      { field: 'companyPersonName', minLength: 3, errorMessage: 'Nome do responsável precisa ter no mínimo 3 caracteres.' }
    ],    
    nextButtonLabel: 'Avançar'
    /*actionRequired:'documentReady'*/
  },
  1: {
    requiredFields: (data) => {
      const obrigatorios = ['companyWppPhone', 'companyMainEmail', 'companyBusinessType', 'servicesOffered', 'technicalResponsibleName', 'technicalResponsibleNumber', 'technicalResponsibleUf'];
      
      // 🔥 Só adiciona 'serviceCategories' se o tipo não for 'oticas'
      if (data?.companyBusinessType !== 'oticas') {
        obrigatorios.push('serviceCategories');
      }
      
      return obrigatorios;
    },
    fieldMatches: [],
    actionRequired: null, //'documentReady',
    fieldValidations: [
      { field: 'companyMainEmail', validator: 'validarEmail', errorMessage: 'Email inválido.' },
      { field: 'companyWppPhone', validator: 'validarTelefone', errorMessage: 'Telefone inválido.' }
    ],         
    nextButtonLabel: 'Avançar'
  },  
  /*1: {
    requiredFields:['companyWppPhone', 'companyMainEmail', 'companyBusinessType', 'serviceCategories', 'servicesOffered','technicalResponsibleName','technicalResponsibleNumber','technicalResponsibleUf'],
    fieldMatches: [],
    actionRequired: null,//'documentReady',
    fieldValidations:[
      { field: 'companyMainEmail', validator: 'validarEmail', errorMessage: 'Email inválido.' },
      { field: 'companyWppPhone', validator: 'validarTelefone', errorMessage: 'Telefone inválido.' }
    ],         
    nextButtonLabel: 'Avançar'
  },*/
  2: {
    requiredFields:['addressObj','neighborhood','city','uf'],
    fieldMatches: [],
    actionRequired: null,
    nextButtonLabel: 'Avançar'
  },
  3: {
    requiredFields:[],
    fieldMatches: [],
    actionRequired: null,
    fieldValidations: [
      { field: 'additionalEmails', validator: 'validarEmail', errorMessage: 'Email inválido.' },
      { field: 'additionalPhones', validator: 'validarTelefone', errorMessage: 'Telefone inválido.' },
      {
        field: 'website',
        validator: 'validarWebsite',
        errorMessage: 'O endereço do site informado não é válido.'
      }      
    ],     
    nextButtonLabel: 'Avançar'
  },
  4: {
    requiredFields: (data) => {
      const obrigatorios = [];
  
      // Se o usuário **não** optou por pular o cartão
      if (!data?.skipCardInfo) {
        obrigatorios.push('cardNumber', 'cardHolderName', 'cardExpiry','cardCvv', 'cardHolderCpf');
      }
  
      // Se o usuário **não** optou por usar o endereço da empresa para faturar
     /* if (!data?.useCompanyAddressForBilling) {
        obrigatorios.push(
          'billingAddress.address',
          'billingAddress.neighborhood',
          'billingAddress.city',
          'billingAddress.uf',
          'billingDocument',
        );
      }*/
  
      return obrigatorios;
    },
    fieldMatches: [],
    actionRequired:null,
    fieldValidations: (data) => {
      const rules = [];
    
      if (!data?.creditCardLater) {
        rules.push(
          {
            field: 'cardNumber',
            validator: 'validarNumeroCartao',
            errorMessage: 'Número do cartão inválido.'
          },
          {
            field: 'cardHolderName',
            validator: 'validarNomeCartao',
            errorMessage: 'Informe o nome completo como está no cartão.'
          },
          {
            field: 'cardExpiry',
            validator: 'validarValidadeCartao',
            errorMessage: 'Data de validade inválida.'
          },
          {
            field: 'cardCvv',
            validator: 'validarCVVComNumero',
            errorMessage: 'CVV inválido para a bandeira do cartão.'
          },
          {
            field: 'cardHolderCpf',
            validator: 'validarCPF',
            errorMessage: 'CPF inválido para o proprietário do cartão.'
          }
        );
      }
    
      rules.push({
        field: 'billingDocument',
        validator: 'validarCNPJ',
        errorMessage: 'CNPJ inválido para faturamento do serviço.'
      });
    
      return rules;
    },
    nextButtonLabel: 'Avançar para revisão'
  },
  5: {
    requiredFields: ['acceptTerms'],
    fieldMatches: [],
    actionRequired: null,
    nextButtonLabel: 'Avançar'
  },
  6: {
    requiredFields: [],
    fieldMatches: [],
    actionRequired: null,
    nextButtonLabel: 'Ir para painel'
  }
};

const fieldNamesMap = {
  companyDocument: 'CNPJ da Empresa',
  companyDocumentSearched: 'Busca de CNPJ Realizada',
  companyLegalName: 'Razão Social',
  companyFantasyName: 'Nome Fantasia',
  personCompanyName: 'Nome do Responsável Legal',
  companyPersonDocument: 'CPF do Responsável Legal',
  companyPersonName: 'Nome do Responsável Legal',
  personUserPhone: 'Telefone do usuário',
  personUserEmail: 'Email do usuário',
  personUserEmailConfirm: 'Confirmação de Email do usuário',
  personUserPassword: 'Senha de Acesso',
  personUserPasswordConfirm: 'Confirmação de Senha de Acesso',

  companyTechnicalResponsibleName: 'Nome do responsável técnico',
  companyTechnicalResponsibleNumber: 'CRM do responsável técnico',
  companyTechnicalResponsibleUf: 'UF do CRM do responsável técnico',

  addressObj: 'Endereço',
  neighborhood: 'Bairro',
  city: 'Cidade',
  uf: 'UF',
  
  additionalEmails: 'Emails adicionais',
  additionalPhones: 'Telefones adicionais',
  website: 'Website',


  
  cardHolderName: 'Nome impresso no cartão',
  cardExpiry: 'Validade do cartão',
  cardHolderCpf: 'CPF do titular do cartão',
  
  'billingAddress.address':'Endereço de faturamento',
  'billingAddress.neighborhood':'Bairro de faturamento',
  'billingAddress.city':'Cidade de faturamento',
  'billingAddress.uf':'UF de faturamento',  
   billingDocument: 'CNPJ para faturamento',
  
  companyMainEmail: 'Email principal da empresa',
  companyWppPhone: 'Telefone WhatsApp da empresa',
  companyBusinessType: 'Tipo de negócio',
  companyDescription: 'Descrição do negócio',
  serviceCategories: 'Subespecialidades selecionadas',
  servicesOffered: 'Serviços oferecidos',
  companyDocuments: 'Documentos enviados',
  selectedDocumentType: 'Tipo de documento selecionado',
  sendDocumentsLater: 'Opção de enviar documentos depois',
  technicalResponsibleName: 'Nome do responsável técnico',
  technicalResponsibleNumber: 'CRM do responsável técnico',
  technicalResponsibleUf: 'UF do CRM do responsável técnico',
  cardNumber: 'Número do cartão',
  cardCvv: 'CVV do cartão',

  acceptTerms: 'Aceite da Política de Privacidade e dos Termos de Uso',
  acceptTerm: 'Aceite da Política de Privacidade e dos Termos de Uso',

  validatedContact: 'Email e/ou Telefone com código validado',
  createdUser: 'Usuário Criado',
  documentReady: 'Você deve enviar ao menos um documento solicitado para análise. Se preferir, marque a opção "Quero enviar depois"',
};

/* Valida etapa atual com base em regras definidas */
const validarEtapa = () => {
  const data = partnerStepData[activeStep];
  const validation = stepValidations[activeStep];

  if (!validation) {
    return { valid: true, missingFields: [], fieldMismatch: null, invalidFields: [], actionRequiredFailed: null };
  }

  const requiredFields = typeof validation.requiredFields === 'function'
    ? validation.requiredFields(data)
    : validation.requiredFields || [];

    const missingFields = requiredFields.filter(field => {
      const value = getNestedValue(data, field);
      return (
        value === undefined ||
        value === null ||
        value === '' ||
        value === false ||
        (Array.isArray(value) && value.length === 0)
      );
    });

  // Validação de campos que precisam ser iguais
  let fieldMismatch = null;
  if (validation.fieldMatches) {
    for (const { field, matchTo, errorMessage } of validation.fieldMatches) {
      if (data?.[field] !== data?.[matchTo]) {
        fieldMismatch = { field, matchTo, errorMessage };
        break;
      }
    }
  }

  // Validação de integridade de campos
  const invalidFields = [];
  const fieldValidations = typeof validation.fieldValidations === 'function'
    ? validation.fieldValidations(data)
    : validation.fieldValidations || [];

  for (const rule of fieldValidations) {
    const value = data?.[rule.field] || '';
    const validatorFn = typeof rule.validator === 'function'
      ? rule.validator
      : ValidatorsMap[rule.validator];

    const isValid =
      validatorFn
        ? validatorFn(value)
        : rule.minLength
        ? value.length >= rule.minLength
        : true;

    if (!isValid) {
      invalidFields.push({
        field: rule.field,
        errorMessage: rule.errorMessage
      });
    }
  }

  // Validação de ações obrigatórias (ex: aceitar termos)
  let actionRequiredFailed = null;
  if (validation.actionRequired && data?.[validation.actionRequired] !== true) {
    actionRequiredFailed = validation.actionRequired;
  }

  return {
    valid:
      missingFields.length === 0 &&
      fieldMismatch === null &&
      actionRequiredFailed === null &&
      invalidFields.length === 0,
    missingFields,
    fieldMismatch,
    actionRequiredFailed,
    invalidFields
  };
  
};


const confirmarFinalizacao_ = () => {
  
  setCompletedSteps([...new Set([...completedSteps, activeStep])]);
  
  // set button loading
  setSaving(true);

  // set global loading ON
  setGlobalInnerMessage("Processando o seu cadastro...Aguarde! isso pode demorar alguns segundos...");
  setGlobalInnerLoading(true);


  // Processar cadastro.
  // ....

  // Cria timer para timeout em caso de demorar muito para processar. 
  // ...

  // Caso processe, cancelar o timer criado
  // ...

  // Mensagem de sucesso
  setTimeout(function() {

    setSaving(false);

    // set global loading ON
    setGlobalInnerLoading(false);    


    // Afer completition, clean formFields var
    // ....


    /*setAlert(true);
    setAlertTitle("Tudo certo! Cadastro concluído!");
    setAlertBody("Excelente! Seu cadastro foi concluído com sucesso. Você receberá um e-mail de confirmação em breve.");*/
    
    // Set last active step with confirmation
    setActiveStep(6);

  },12000);
  
  // Se tudo deu certo, redirecionar para página de confirmação
  // ...

};

const confirmarFinalizacao = async () => {
  try {

  // set button loading
    setSaving(true);

    // set global loading ON
    setGlobalInnerMessage("Processando o seu cadastro...Aguarde! isso pode demorar alguns segundos...");
    setGlobalInnerLoading(true);

    const resultado = await registerPartner();
    
    setSaving(false);
    setGlobalInnerLoading(false);

    if (resultado.success && resultado.token) {
      // ✅ Login automático — AQUI você executará o login com o token retornado

			// save User Data on Local Storage
			//localStorage.setItem("@estacaodoolho/userData", resultado.token);
			//localStorage.setItem("@estacaodoolho/logged",1);

     // setLoginStatus(true);
     // setUserProfile("partner");

      // Marca como finalizado
      setCompletedSteps([...new Set([...completedSteps, activeStep])]);
      setActiveStep(6); // Etapa de finalização
      return;
    }

    // 💥 Se falhou, mostra alerta com erro interpretado
    setAlertTitle("Erro ao concluir cadastro");
    setAlertBody(resultado.errorMessage || "Houve uma falha inesperada. Tente novamente.");
    setAlert(true);    

  } catch (error) {
    console.error("Erro inesperado ao confirmar finalização:", error);
    setSaving(false);
    setGlobalInnerLoading(false);
    setAlertTitle("Erro inesperado");
    setAlertBody("Houve uma falha não prevista. Tente novamente.");
    setAlert(true);
  }
};

const cancelarFinalizacao = () => {
  
  setSubmitConfirmVisible(false);
  
  // set global loading ON
  setGlobalInnerLoading(false);

}

const handleNext = async () => {
  const { valid, missingFields, fieldMismatch, invalidFields, actionRequiredFailed } = validarEtapa();

  if (valid) {


    // Verifica se dados do cartao foram inputados e gera token da IUGU
    if (activeStep === 4 && !partnerStepData[4]?.creditCardLater) {

      // Set button loading on
      setSaving(true);

      const step5Data = partnerStepData[4];

      const [expMonth, expYearShort] = step5Data.cardExpiry.split('/');
      const cardData = {
        number: step5Data.cardNumber.replace(/\D/g, ''),
        verification_value: step5Data.cardCvv,
        first_name: step5Data.cardHolderName.split(' ')[0],
        last_name: step5Data.cardHolderName.split(' ').slice(1).join(' ') || '.',
        month: expMonth,
        year: '20' + expYearShort,
      };

      const alreadyTokenized = step5Data.cardToken && JSON.stringify(cardData) === JSON.stringify(step5Data.lastTokenizedCardData);

      if (!alreadyTokenized) {
        try {
          const token = await tokenizarCartao(cardData, setAlert, setAlertTitle, setAlertBody);
          updateStepData(4, { cardToken: token, lastTokenizedCardData: cardData }); // Armazena no Redux/local
        } catch (err) {
          
          console.error('Erro ao tokenizar cartão:', err.message);
          setAlert(true);
          setAlertTitle('Erro ao tokenizar cartão');
          setAlertBody('Houve um erro ao processar o cartão de crédito. Verifique os dados e tente novamente.');
          
          // turn of button loading
          setSaving(false);  

          return;
        }
      } // end if

    }    
    
    if (!completedSteps.includes(activeStep)) {
      setCompletedSteps([...completedSteps, activeStep]);
    }

    if (activeStep === totalSteps - 1) {
      setSubmitConfirmVisible(true);
      return;
    } else {
      setActiveStep((prev) => prev + 1);
      handleClickScroll('partnerMainSection');
    }

    // turn of button loading
    setSaving(false);

  } else {
    let alertBodyContent = null;
    let firstInvalidFieldId = null;

    const renderErrorGroup = (title, items) => (
      <>
        <strong>{title}</strong><br />
        {items.map((msg, i) => (
          <React.Fragment key={i}>
            - {msg}<br />
          </React.Fragment>
        ))}
        <br />
      </>
    );

    const requiredErrors = [];
    const validationErrors = [];
    const mismatchErrors = [];
    const actionErrors = [];

    if (missingFields.length > 0) {
      missingFields.forEach((field) => {
        requiredErrors.push(`${fieldNamesMap[field] || field}`);
      });
      firstInvalidFieldId = missingFields[0];
    }

    if (invalidFields.length > 0) {
      invalidFields.forEach(({ field, errorMessage }) => {
        validationErrors.push(`${fieldNamesMap[field] || field}: ${errorMessage}`);
      });
      if (!firstInvalidFieldId) firstInvalidFieldId = invalidFields[0]?.field;
    }

    if (fieldMismatch) {
      mismatchErrors.push(`${fieldNamesMap[fieldMismatch.field] || fieldMismatch.field}: ${fieldMismatch.errorMessage}`);
      if (!firstInvalidFieldId) firstInvalidFieldId = fieldMismatch.field;
    }

    if (actionRequiredFailed) {
      const actionMessage = fieldNamesMap[actionRequiredFailed]
        ? `${fieldNamesMap[actionRequiredFailed]}`
        : 'Por favor, complete a ação necessária.';
      actionErrors.push(actionMessage);
    }

    alertBodyContent = (
      <>
        Corrija os seguintes pontos antes de continuar:
        <br /><br />
        {requiredErrors.length > 0 && renderErrorGroup('Campos obrigatórios:', requiredErrors)}
        {validationErrors.length > 0 && renderErrorGroup('Validação de campos:', validationErrors)}
        {mismatchErrors.length > 0 && renderErrorGroup('Campos que devem coincidir:', mismatchErrors)}
        {actionErrors.length > 0 && renderErrorGroup('Ações obrigatórias:', actionErrors)}
      </>
    );

    setAlertTitle('Atenção');
    setAlertBody(alertBodyContent);
    setAlert(true);

    // 🔎 Scroll até o primeiro campo inválido
    if (firstInvalidFieldId) {
      const element = document.getElementById(firstInvalidFieldId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        element.focus({ preventScroll: true });
      }
    }
  }
};

const handlePrevious = () => {

    setActiveStep((prev) => prev - 1);

    // animate scroll to top
    handleClickScroll('partnerMainSection');

};

const handleStepClick = (targetStep) => {
  if (targetStep === activeStep) return;

  if (targetStep < activeStep) {
    // permitir voltar para etapas anteriores já concluídas
    setActiveStep(targetStep);
    handleClickScroll('partnerMainSection');
    return;
  }

  // não permitir pular etapas não concluídas
  const isCurrentValid = validarEtapa();
  if (isCurrentValid.valid) {
    setCompletedSteps([...new Set([...completedSteps, activeStep])]);
    setActiveStep(targetStep);
    handleClickScroll('partnerMainSection');
  } else {
    // força o usuário a corrigir erros primeiro
    handleNext();
  }
};
 
/* Steper Title Logic */
const stepTitles = [
    'Cadastro',
    'Sobre o negócio',
    'Endereço do negócio',
    'Dados complementares',
    'Pagamento e Faturamento',
    'Revisão e confirmação'
  ];

/* Steper Content Logic */
const StepperContent = (props) => {

    const { activeStep, setAlert, setAlertTitle, setAlertBody } = props;
  
    const steps = [
      <RegisterStep1 key={0} stepIndex={0} setAlert={setAlert} setAlertTitle={setAlertTitle} setAlertBody={setAlertBody} stepValidations={stepValidations[0]} />,
      <RegisterStep2 key={1} stepIndex={1} setAlert={setAlert} setAlertTitle={setAlertTitle} setAlertBody={setAlertBody} stepValidations={stepValidations[1]} />,
      <RegisterStep3 key={2} stepIndex={2} setAlert={setAlert} setAlertTitle={setAlertTitle} setAlertBody={setAlertBody} stepValidations={stepValidations[2]} />,
      <RegisterStep4 key={3} stepIndex={3} setAlert={setAlert} setAlertTitle={setAlertTitle} setAlertBody={setAlertBody} stepValidations={stepValidations[3]} />,
      <RegisterStep5 key={4} stepIndex={4} setAlert={setAlert} setAlertTitle={setAlertTitle} setAlertBody={setAlertBody} stepValidations={stepValidations[4]} />,
      <RegisterStep6 key={5} stepIndex={5} setAlert={setAlert} setAlertTitle={setAlertTitle} setAlertBody={setAlertBody} stepValidations={stepValidations[5]} />,
      <RegisterConfirm key={6} stepIndex={6} setAlert={setAlert} setAlertTitle={setAlertTitle} setAlertBody={setAlertBody} stepValidations={stepValidations[6]} />,
    ];
  
    return steps[activeStep] || null;
  };

  /* Load form data */
  React.useEffect(() => {
    retrieveCompanyServices();
    retrieveCompanyDiscounts();
    retrieveCompanySpecialities();
  }, []);


  /* Load IUGU Script for CC tokenization */
  React.useEffect(() => {
  const scriptId = 'iugu-js-sdk';

  const existingScript = document.getElementById(scriptId);
  if (!existingScript) {
    const script = document.createElement('script');
    script.id = scriptId;
    script.src = 'https://js.iugu.com/v2';
    script.async = true;

    script.onload = () => {
      if (window.Iugu) {
        window.Iugu.setAccountID('9F5FFF606C5B4B718AFBAB5DC1C918FB');
        window.Iugu.setTestMode(false); // true se estiver em sandbox
        console.log('[IUGU] Script carregado.');
      }
    };

    script.onerror = () => {
      console.error('[IUGU] Falha ao carregar o script.');
    };

    document.body.appendChild(script);
  } else {
    if (window.Iugu) {
      window.Iugu.setAccountID('9F5FFF606C5B4B718AFBAB5DC1C918FB');
      window.Iugu.setTestMode(true);
    }
  }

  return () => {
    // 🔥 Ao sair do fluxo de cadastro, remove o script
    const script = document.getElementById(scriptId);
    if (script) {
      document.body.removeChild(script);
      console.log('[IUGU] Script removido.');
    }

  };
}, []);
 
// If not logged, show login screen
  return (
    <>
    <Helmet>
      <title>Cadastro de parceiro</title>
      <meta name="description" content="Cadastre-se na Estação de Olho para começar a receber direcionamentos." />
      <meta name="keywords" content="oftalmologia, clínica, saúde ocular, exames de vista" />
    </Helmet>    
    <div id="partnerMainSection" className="wrapper_partner__content">

        <HeaderView />

        <div className={isMobile ? "mobileWrapperBox wrapper_partner__content_container" : "wrapper_partner__content_container"}> 
        
            {/*<!-- Inner Content Wrapper -->*/}
            <div className={isMobile ? "wrapper_partner__inner_content_container_block mobileWrapper" : "wrapper_partner__inner_content_container_block"} style={{marginTop:isMobile ? "0" : "2rem"}}>


                {/*<!-- Steper with content -->*/}
                <div className="wrapper_partner__content_container_block">  

                    {activeStep < 6 && (
                      <div className="wrapper_partner__content_container_stepByStep" style={{marginTop:"5rem"}}>
                      <div className="title">{stepTitles[activeStep] || 'Cadastro'}</div>
                          <div className="control">
                              <CustomStepper 
                                totalSteps={totalSteps} 
                                activeStep={activeStep} 
                                completedSteps={completedSteps} 
                                onStepClick={handleStepClick}
                                stepTitles={stepTitles}                              
                              />
                          </div>            
                      </div>
                    )}

                    <div className="wrapper_partner__content_container_form" style={{marginTop:"2.5rem",minHeight:"50vh",marginBottom:"9rem"}}>
      
                        <StepperContent activeStep={activeStep} setAlert={setAlert} setAlertTitle={setAlertTitle} setAlertBody={setAlertBody} />

                        {activeStep < 6 && (
                          <div className="stepper-buttons" style={{marginTop:"2rem",display:"flex",justifyContent:"center",alignItems:"center",gap:"1rem",padding:"0 2rem"}}>
                              {activeStep > 0 && (
                                  <Button onClick={handlePrevious} text className="pT10">
                                  Voltar
                                  </Button>
                              )}
                              
                                <Button
                                onClick={handleNext}
                                rounded
                                loading={saving}
                                disabled={activeStep === totalSteps - 1 && saving}
                                className="pT10 headerButtonRight filled"
                                /*disabled={!validarEtapa()}*/
                                style={{ width: "unset", paddingLeft:"1rem",paddingRight:"1rem" }}
                                >
                                {activeStep === totalSteps - 1 ? 'Finalizar cadastro' : stepValidations[activeStep].nextButtonLabel }
                                </Button>
                          </div>         
                        )}               

                    </div>				

                </div>		

            </div>		

        </div>

      <AlertView
        alert={alert}
        setAlert={setAlert}
        alertTitle={alertTitle}
        alertBody={alertBody}	
        setAlertAction={setAlertAction}
        scrollBlock={false}			
      />

      <ConfirmDialog
        visible={submitConfirmVisible}
        onHide={() => setSubmitConfirmVisible(false)}
        message="Tem certeza que quer finalizar o cadastro com os dados informados?"
        header="Confirmar envio"
        icon="pi pi-question-circle"
        acceptClassName="pT10 headerButtonRight filledNoWidth"
        rejectClassName="pT10 headerButtonRight outlined"
        className="stepConfirm"
        acceptLabel="Sim, finalizar"
        rejectLabel="Revisar"
        accept={confirmarFinalizacao}
        reject={() => cancelarFinalizacao}
      />      

    </div>
    </>
  );
   
}

const mapStateToProps = store => ({
  dialog:store.appReducer.dialog,
  loginStatus:store.appReducer.loginStatus,
  currentCompanyStatus:store.appReducer.currentCompanyStatus,
  activationStatus:store.appReducer.activationStatus,
  partnerStepData: store.partnerReducer.stepData,
  servicesList: store.partnerReducer.servicesList,
  specialitiesList: store.partnerReducer.specialitiesList,
  globalLoading: store.appReducer.globalLoading,
  userProfile: store.appReducer.userProfile
 });
const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions, ...PartnerActions }, dispatch);

export default connect(
        mapStateToProps,
        mapDispatchToProps
    )(RegisterMain);	

